<template>
  <ion-header>
    <ion-toolbar>
      <ion-item lines="none">
        <ion-title v-if="!selectedCard.pointPackages" slot="start">{{ $t('addCredit') }}</ion-title>
        <ion-title v-if="selectedCard.pointPackages" slot="start">{{ $t('recharge') }}</ion-title>
        <ion-icon slot="end" style="font-size: 30px;" @click="closeDialog()" :ios="closeOutline" :md="closeOutline" class="ion-float-right"></ion-icon>
      </ion-item>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <ion-list lines="full" class="ion-no-margin">
      <ion-item v-if="selectedCard.pointPackages">
        <ion-label position="stacked">{{ $t('pointPackages')}}</ion-label>
        <ion-select style="min-width: 100% !important;" interface="popover" v-model="pointPackage" :value="JSON.parse(selectedCard.pointPackages)[0].articleID">
          <ion-select-option v-for="(item, index) in JSON.parse(selectedCard.pointPackages)" :key="index" :value="item.articleID">{{ item.points }} {{ $t('points') }} {{ $t("for") }} {{ item.amountStr }}</ion-select-option> 
        </ion-select>
      </ion-item>
      <ion-item v-if="!selectedCard.pointPackages">
        <ion-label position="stacked">{{ $t('amount')}}</ion-label>
        <ion-select style="min-width: 100% !important;" interface="popover" v-model="creditamount" :value="creditamount">
          <ion-select-option value="20">20</ion-select-option>          
          <ion-select-option value="50">50</ion-select-option>          
          <ion-select-option value="100">100</ion-select-option>          
        </ion-select>
      </ion-item>
      <ion-item v-if="(!selectedCard.pointPackages && clubInfo && clubInfo.clubInfo && clubInfo.clubInfo.canLastschrift)">
        <ion-label slot="start">{{ $t('payLastschrift')}}</ion-label>
        <ion-checkbox v-model="lastschriftChecked" slot="end"></ion-checkbox>
      </ion-item>
      <ion-item v-if="lastschriftChecked">
        <ion-label class="ion-text-wrap">{{ $t('payLastschriftHint')}}</ion-label>
        <ion-button :disabled="lastschriftClicked" @click="rechargeByLastschrift()" color="success">{{ $t('addCreditLastschrift') }}</ion-button>
      </ion-item>
      <ion-grid class="ion-no-margin ion-no-padding">
        <ion-row>
          <ion-col>
            <ion-item v-show="clubInfo && clubInfo.clubInfo && clubInfo.clubInfo.canPaypal && !lastschriftChecked">
              <ion-label position="stacked">{{ $t('paymenttype')}}</ion-label>
                <div style="margin-top: 5px;" id="paypalButton"></div>
            </ion-item>
          </ion-col>
          <ion-col>
            <div v-show="clubInfo && clubInfo.clubInfo && clubInfo.clubInfo.canMeteorPayment && !lastschriftChecked" style="margin: 20px;">      
              <PaymentButton
                :amount="creditamount"
                @payment-success="handleSuccess"
                @payment-failed="handleFailed"
                  />
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>

      <!-- <ion-button :disabled="rechargeDisabled" @click="recharge()" expand="block" color="success">{{ $t('recharge') }}</ion-button>-->
    </ion-list>
  </ion-content>
</template>

<script>
import { toastController, IonSelect, IonSelectOption, IonButton, IonContent, 
          IonHeader, IonTitle, IonToolbar, IonLabel, IonInput, IonItem, IonList, IonIcon, IonGrid, IonToggle,
          IonCol, IonRow, modalController, IonDatetime, loadingController } from '@ionic/vue';
import { defineComponent, ref } from 'vue';
import { closeOutline } from 'ionicons/icons';
import addCreditMutationFile from '../../graphql/addCredit.mutation.gql'
import createPaymentMutationFile from '../../graphql/createPayment.mutation.gql'
import { useMutation } from '@vue/apollo-composable'
import { loadScript } from "@paypal/paypal-js";
import { getClubInfo } from '@/composition'
import store from '../../main'
import PaymentButton from "./PaymentButton.vue";
import translate from '@/plugins/translate';


export default defineComponent({
  name: 'AddCreditDialog',
  components: { IonButton, IonContent, IonHeader, IonTitle, IonToolbar,IonLabel, IonInput, IonItem, 
                IonList, IonIcon, IonGrid, IonCol, IonRow, IonSelect, IonSelectOption, IonToggle, IonDatetime, PaymentButton },
  props: ['propsData'],
  computed: {
      isSuccessfullBraintreePaypalAuthorized : function(){ return this.$store.getters.isSuccessfullBraintreePaypalAuthorized},
      isSuccessfullBraintreeCreditCardAuthorized : function(){ return this.$store.getters.isSuccessfullBraintreeCreditCardAuthorized },
  },
  mounted() {
    loadScript({ "client-id": this.clubInfo.clubInfo.paypalClientID, currency: this.clubInfo.clubInfo.currency }).then((paypal) => {
    paypal.Buttons({
        style: {
          shape: 'rect',
          color: 'blue',
          layout: 'vertical',
          label: 'pay',
          
        },
        createOrder: async () => {
          const p = await this.createPaymentMutation({ description: 'Guthaben', amount: this.selectedCard.pointPackages ? parseFloat(JSON.parse(this.selectedCard.pointPackages).find(f => f.articleID == this.pointPackage).amount) : parseFloat(this.creditamount), paymentType: 'payPal'})
          if (!p.data.createPayment.success) {
            return ''
          }
          return p.data.createPayment.token
         },
         onError: async () => {
            toastController
              .create({
                message: this.$t('invalidPayment'),
                duration: 3000,
                color: 'danger'
              }).then(res => res.present())
         },
         onApprove: async (data,actions) => {
            this.buttonDisabled = true
            loadingController.create().then(res => {
              res.present()
            }).catch(err => { })
            this.addCreditMutation({ 
              amount: this.selectedCard.pointPackages ? parseFloat(JSON.parse(this.selectedCard.pointPackages).find(f => f.articleID == this.pointPackage).amount) : parseFloat(this.creditamount),
              type: this.paymenttype,
              uid: this.selectedCard.uid,
              orderId: data.orderID,
              points: this.selectedCard.pointPackages ? parseInt(JSON.parse(this.selectedCard.pointPackages).find(f => f.articleID == this.pointPackage).points) : 0 
              })
            .then(res => {
                toastController
                  .create({
                    message: this.$t('addSuccessful'),
                    duration: 3000,
                    color: 'success'
                  }).then(res => res.present())
                  loadingController.dismiss()
                  return modalController.dismiss(true)
            })
            .catch(err => {
                loadingController.dismiss()
                toastController
                  .create({
                    message: this.$t('addNotSuccessful') + ': ' + err,
                    duration: 3000,
                    color: 'danger'
                  }).then(res => res.present())
            }) 
         },
         onCancel: async () => {
          await this.createPaymentMutation({ amount: parseFloat(this.creditamount), paymentType: 'payPalCancel' })
         }
     }).render("#paypalButton")});

    this.paymenttype = 'PayPalAccount'
    /*if (this.isSuccessfullBraintreePaypalAuthorized && this.isSuccessfullBraintreeCreditCardAuthorized )
      this.paymenttype = 'PayPalAccount'
    else if (this.isSuccessfullBraintreePaypalAuthorized)
      this.paymenttype = 'PayPalAccount'
    else if (this.isSuccessfullBraintreeCreditCardAuthorized)
      this.paymenttype = 'CreditCard' */
  },
  setup(props) {
    const creditamount = ref('50')
    const paymenttype = ref('')
    const rechargeDisabled = ref(false)
    let selectedCard = props.propsData.selectedCard
    const clubInfo = ref(getClubInfo())
    const lastschriftChecked = ref(false)
    const lastschriftClicked = ref(false)
    const pointPackage = ref(selectedCard.pointPackages ? JSON.parse(selectedCard.pointPackages)[0].articleID: 0)

    const { mutate: addCreditMutation } = useMutation(addCreditMutationFile, { fetchPolicy: 'no-cache' });
    const { mutate: createPaymentMutation } = useMutation(createPaymentMutationFile, { fetchPolicy: 'no-cache' });

    const message = ref("");

    // 🔵 Zahlung erfolgreich
    function handleSuccess(result) {
      addCreditMutation({ 
        amount: selectedCard.pointPackages ? parseFloat(JSON.parse(selectedCard.pointPackages).find(f => f.articleID == pointPackage.value).amount) : parseFloat(creditamount.value),
        type: 'meteor',
        uid: selectedCard.uid,
        orderId: result.id,
        points: selectedCard.pointPackages ? parseInt(JSON.parse(selectedCard.value.pointPackages).find(f => f.articleID == pointPackage.value).points) : 0 
      })
      .then(res => {
          toastController
            .create({
              message: translate('addSuccessful'),
              duration: 3000,
              color: 'success'
            }).then(res => res.present())
            return modalController.dismiss(true)
      })
      .catch(err => {
          toastController
            .create({
              message: translate('addNotSuccessful') + ': ' + err,
              duration: 3000,
              color: 'danger'
            }).then(res => res.present())
      })       
    }

    // 🔴 Zahlung fehlgeschlagen
    function handleFailed(result) {
      message.value = "Zahlung fehlgeschlagen oder abgebrochen.";
    }

    return {
      closeOutline, addCreditMutation, creditamount, paymenttype, rechargeDisabled, selectedCard, createPaymentMutation, clubInfo, lastschriftChecked, lastschriftClicked, pointPackage, handleSuccess, handleFailed, message
    }
  },
  methods: {
    closeDialog() {
      return modalController.dismiss()
    },
    async rechargeByLastschrift() {
      this.lastschriftClicked = true
      this.addCreditMutation({ 
              amount: parseFloat(this.creditamount),
              type: 'Lastschrift',
              uid: this.selectedCard.uid,
              orderId: Math.floor(Math.random() * 10000).toString()
              })
            .then(res => {
              if (res.data.addCredit.success == true){
                toastController
                  .create({
                    message: this.$t('addSuccessful'),
                    duration: 3000,
                    color: 'success'
                  }).then(res => res.present())
                  loadingController.dismiss()
                  return modalController.dismiss(true)
              }
              else if (res.data.addCredit.success == false && res.data.addCredit.errorCode && res.data.addCredit.errorCode != '') {
                toastController
                  .create({
                    message: this.$t(res.data.addCredit.errorCode),
                    duration: 3000,
                    color: 'danger'
                  }).then(res => res.present())
              }
              else {
                toastController
                  .create({
                    message: this.$t('addNotSuccessful'),
                    duration: 3000,
                    color: 'danger'
                  }).then(res => res.present())
              }
              
            })
            .catch(err => {
                loadingController.dismiss()
                toastController
                  .create({
                    message: this.$t('addNotSuccessful') + ': ' + err,
                    duration: 3000,
                    color: 'danger'
                  }).then(res => res.present())
            }) 

    },
    async recharge() {
      loadingController.create().then(res => {
        res.present()
      }).catch(err => { })
      this.rechargeDisabled = true
      this.addCreditMutation({ 
        amount: this.selectedCard.pointPackages ? parseFloat(JSON.parse(this.selectedCard.pointPackages).find(f => f.articleID == this.pointPackage).amount) : parseFloat(this.creditamount),
        type: this.paymenttype,
        uid: this.selectedCard.uid,
        points: this.selectedCard.pointPackages != null ? JSON.parse(this.selectedCard.pointPackages).find(f => f.articleID == this.pointPackage).points : 0
        })
      .then(res => {
        if (res && res.data && res.data.addCredit && res.data.addCredit.success) {
          toastController
            .create({
              message: this.$t('addSuccessful'),
              duration: 2000,
              color: 'success'
            }).then(res => res.present())
            loadingController.dismiss()
            return modalController.dismiss(this.creditamount)
        }
        else {
          loadingController.dismiss()
          toastController
            .create({
              message: res.data.addCredit + this.$t('addNotSuccessful'),
              duration: 2000,
              color: 'danger',
            }).then(res => res.present())
        }
        })
      .catch(err => {
          toastController
            .create({
              message: err + this.$t('addNotSuccessful'),
              duration: 2000,
              color: 'danger',
            }).then(res => res.present())
        })
    },
  }
});


</script>

<style scoped>
ion-item {
  --ion-background-color: white !important;
  --padding-start: 0;
  --padding-end: 0;
  
  --inner-padding-start: 0;
  --inner-padding-end: 0;
  
  --min-height: 0;
}

</style>